module.exports = __webpack_public_path__ + "img/Kapselwurf_Logo.b4dfda1b.png";